__webpack_require__.p = "/dev/921-tdd-create-new-structure-service/";